import { CorrelationId } from '../models/correlation-id';

export const formatCorrelationId = (correlationId: CorrelationId) => {
  return `${correlationId.clientApiKey}_${correlationId.sessionId}_${correlationId.requestId}`;
};
